var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.noticeShow,
          expression: "noticeShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "deleteRemind" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n              " +
              _vm._s(_vm.$t("language.paySystem.Notice")) +
              "\n              "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "delete-remind-content" }, [
          _c(
            "div",
            {
              staticStyle: {
                float: "left",
                width: "100%",
                height: "80px",
                color: "#71767e"
              }
            },
            [_vm._v(" " + _vm._s(_vm.noticeTxt) + " ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "team-footer", staticStyle: { float: "left" } },
            [
              _c("div", { staticClass: "team-botton" }, [
                _c(
                  "button",
                  {
                    staticClass: "team-botton-left",
                    on: {
                      click: function($event) {
                        return _vm.clearPage()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.teamTransfer.sure")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "team-botton-right",
                    on: {
                      click: function($event) {
                        return _vm.closePage()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c88315ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c88315ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/team_transfer_popups/team_transfer_notice_popups.vue
// module id = null
// module chunks = 